'use es6';

import { OLAF } from 'HubStyleTokens/colors';
import styled from 'styled-components';
const PageContainer = styled.div.withConfig({
  displayName: "PageContainer",
  componentId: "epz6uo-0"
})(["background-color:", ";min-height:100vh;"], OLAF);
export default PageContainer;